import React, { useState } from "react";
import { ReactComponent as RightArrowInWhite } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrowInWhite } from "assets/svgs/left-arrow.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import useToggle from "hooks/useToggle";
import { onKeyDown } from "helpers/dom-events";
import Image from "components/image";
import GalleryModal from "components/gallery-modal";

const sliderSettings = {
	slidesPerView: 1,
	preventClicks: true,
	preventClicksPropagation: false,
	noSwiping: true,
	spaceBetween: 10,
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	slidesPerGroup: 1,
	navigation: {
		enabled: true,
		prevEl: ".left-arrow-bwv",
		nextEl: ".right-arrow-bwv",
	},
	a11y: true,
};

const BundleWithVariantsGallery = ({ images }) => {
	const [isModalOpen, setModalOpen] = useToggle(false);
	const [zoomedImgGalleryIndex, setZoomedImgGalleryIndex] = useState(0);

	if (!images || !images?.length) return null;

	const handleOnClick = (image) => () => {
		setModalOpen(true);

		const imgIndex = images.findIndex((img) => img._key === image._key);

		setZoomedImgGalleryIndex(imgIndex);
	};

	return (
		<>
			<GalleryModal
				images={images}
				setImageIndex={setZoomedImgGalleryIndex}
				imageIndex={zoomedImgGalleryIndex}
				setModalOpen={setModalOpen}
				isModalOpen={isModalOpen}
			/>

			<div className="hidden lg:block">
				<div className="my-3">
					<span
						tabIndex={0}
						onClick={handleOnClick(images[0])}
						onKeyDown={onKeyDown(handleOnClick(images[0]))}
						className="cursor-zoom-in relative"
					>
						<Image image={images[0]} />
					</span>
				</div>
				{images.length > 1 && (
					<div className="grid grid-cols-2 gap-5 my-3">
						{images?.slice(1)?.map((image, i) => (
							<div
								key={i}
								className="group w-full cursor-zoom-in"
								onClick={handleOnClick(image)}
								onKeyDown={onKeyDown(handleOnClick(image))}
							>
								<Image key={image._key} image={image.asset} />
							</div>
						))}
					</div>
				)}
			</div>
			<section className="lg:hidden">
				<Swiper {...sliderSettings}>
					{images?.map((img) => (
						<SwiperSlide key={img._key}><Image image={img} /></SwiperSlide>
					))}
					<div className="left-arrow-bwv"><LeftArrowInWhite role="presentation" aria-hidden="true" /></div>
					<div className="right-arrow-bwv"><RightArrowInWhite role="presentation" aria-hidden="true" /></div>
				</Swiper>
			</section>
		</>
	);
};

export default BundleWithVariantsGallery;